import { DatePipe } from '@angular/common';
import { Component, Injector, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BaseResourceListComponent, Coluna, Contrato, DateFormatPipe, Filtro, FormatoExportacao, GlobalService, LoginPublico
} from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContratoService } from '../service/contrato.service';

@Component({
  selector: 'lib-contrato-lst',
  templateUrl: './contrato-lst.component.html'
})
export class ContratoLstComponent extends BaseResourceListComponent<Contrato, LoginPublico> implements OnInit, OnChanges {

  /**
   * Declaração de variáveis
   */
  public ptBR: any;
  public data1: Date;
  public data2: Date;
  public datepipe: DatePipe;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    private route: ActivatedRoute,
    protected injector: Injector,
    public globalService: GlobalService,
    private contratoService: ContratoService) {
    super(contratoService, injector);
    this.route.params.pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        this.data1 = new DateFormatPipe().transform(params['data1'], []);
        this.data2 = new DateFormatPipe().transform(params['data2'], []);
        this.paginaCorrente = +params['pagina'];
        this.filtro = params['filtro'];
      });
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'orgao,favorecido';
  }

  protected condicoesGrid(): {} {
    return {
      ['orgao.id']: this.login.orgao.id
    };
  }

  protected ordenacaoGrid(): string[] {
    return ['data_inicio$ASC'];
  }

  protected filtrosGrid(): Filtro {
    return {};
  }

  public beforeInit(): void {

    if (this.login.exercicio && !this.data1) {
      this.data1 = new Date(`01/01/${this.login.exercicio.ano}`);
      if (this.login.exercicio.ano !== new Date().getFullYear()) {
        this.data2 = new Date(`12/31/${this.login.exercicio.ano}`);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
  }


  protected afterInit(): void {
    window.scrollTo(0, 0);
    this.login.contraste = sessionStorage.getItem('contraste') === 'true';
    this.ptBR = this.globalService.obterDataBR();
  }

  protected acaoRemover(model: Contrato): Observable<Contrato> {
    return null;
  }

  public obterParametros() {
    const parametros = {};
    this.datepipe = new DatePipe('pt');
    parametros['ignoreCondObrig'] = true;
    parametros['data_inicio$ge'] = this.datepipe.transform(this.data1, 'yyyy-MM-dd');
    parametros['data_inicio$le'] = this.datepipe.transform(this.data2, 'yyyy-MM-dd');
    parametros['orgao.id'] = this.login.orgao.id;
    parametros['relations'] = 'orgao,favorecido';
    if (this.filtro) {
      parametros['OR'] =
        // tslint:disable-next-line: max-line-length
        `favorecido.nome$like=${this.filtro}%;!;!;numero$like=${this.filtro};!;!;valor_contrato=${this.filtro}`;
    }
    switch (this.col) {
      case 1:
        parametros['orderBy'] = `numero$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 2:
        parametros['orderBy'] = `data_inicio$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 3:
        parametros['orderBy'] = `data_termino$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 4:
        parametros['orderBy'] = `favorecido.nome$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 5:
        parametros['orderBy'] = `tipo_contratacao.nome$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 6:
        parametros['orderBy'] = `valor_contrato$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      default:
        break;
    }

    return parametros;
  }

  public preencherGrid() {
    const parametros = this.obterParametros();
    this.contratoService
      .filtrar(
        this.paginaCorrente,
        this.login.limite,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          this.lista = lista.content;
          this.paginaTotal = lista.totalPages;
        },
        () => alert('erro ao retornar lista')
      );
  }

  public onSelectPeriodo() {
    this.preencherGrid();
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Número', coluna: 'numero' },
      { titulo: 'Fornecedor', coluna: 'favorecido.nome' },
      { titulo: 'Finalidade', coluna: 'finalidade' },
      { titulo: 'Objeto', coluna: 'objeto' },
      { titulo: 'Início', coluna: 'data_inicio' },
      { titulo: 'Término', coluna: 'data_termino' },
      { titulo: 'Valor', coluna: 'valor_contrato', decimais: 2, alignment: 'right' },
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    this.contratoService
      .filtrar(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          if (formato === 'pdf') {
            this.imprimir('LISTAGEM DE CONTRATOS',
              this.login.usuario.nome, this.login.usuario.sobrenome, this.login.orgao.nome, this.login.brasao, 'landscape',
              'Listagem contratos', ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'], lista.content, ['valor_contrato']);
          } else {
            this.exportar(formato, lista.content);
          }
        },
        () => alert('erro ao retornar lista')
      );
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public editar(id: number) {
    const dt1 = this.datepipe.transform(this.data1, 'yyyy-MM-dd', 'GMT');
    const dt2 = this.datepipe.transform(this.data2, 'yyyy-MM-dd', 'GMT');
    if (!this.filtro || this.filtro === '') {
      this.router.navigate([
        `/contratos/visualiza`, id, this.paginaCorrente, dt1, dt2]);
    } else {
      this.router.navigate([
        `/contratos/visualiza`, id, this.paginaCorrente, dt1, dt2, this.filtro]);
    }
  }

}
